// eslint-disable-next-line import/prefer-default-export
export const SCOPE = 'errorConfig';
export const INIT = `${SCOPE}/INIT`;
